import React from "react";
import _ from "lodash";
import FlusterPlayerList from "../components/FlusterPlayerList";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants, fadeVariants } from "shared/components/animations";
const FLUSJoining = ({ users, screens }) => {
  const waiting_player_word = _.get(
    screens,
    "all_players.1_joining",
    " Waiting for players to join..."
  );

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="flus-joining"
    >
      <motion.h3 variants={fadeVariants} className="joining-heading">
        {waiting_player_word}
      </motion.h3>
      <FlusterPlayerList users={users} isJoining={true} />
    </motion.div>
  );
};

export default FLUSJoining;
